'use strict';

class _Articulo {

    constructor(item) {
        this._id = item._id;
        this.codigo = item.codigo;
        this.descripcion = item.descripcion;
        this.imagenUrl = item.imagenUrl;
        this.categoria = item.categoria;
        this.cantidad = item.cantidad;
        this.precio = item.precio;
        this.precioVisible = item.precioVisible;
    }
}
export default class {

    /*@ngInject*/
    constructor($cookies, $http, ORDENES_URL) {
        Object.assign(this, {$cookies, $http, ORDENES_URL});
        this.listadoArticulos = [];
        let carritoConItems = this.$cookies.getObject('carrito');
        if (carritoConItems && carritoConItems.articulos) {
            this.listadoArticulos = carritoConItems.articulos;
        }
    }

    agregarArticulo(articulo) {
        let artAux = this.listadoArticulos.find(x => x._id === articulo._id);
        if (artAux){
            artAux.cantidad += articulo.cantidad;
        } else {
            this.listadoArticulos.push(new _Articulo(articulo));
        }
        this._actualizarCookies();
    }

    actualizarArticuloCarrito() {
        this._actualizarCookies();
    }
    quitarArticuloCarrito(articulo) {
        let index = this.listadoArticulos.indexOf(articulo);
        if (index != -1) {
            this.listadoArticulos.splice(index, 1);
        }
        this._actualizarCookies();
    }

    vaciarCarrito() {
        this.listadoArticulos = [];
        this._actualizarCookies();
    }

    getArticulosCarrito() {
        return this.listadoArticulos;
    }

    getMontoTotalCarrito() {
        let monto = 0;
        let precioVisible = true;
        for (let item of this.listadoArticulos) {
            monto += (item.precio * item.cantidad);
            if (item.precioVisible === false)
                precioVisible = false;
        }
        if(!precioVisible)
            monto = 0;
        return monto;
    }

    getCantidadArticulos(){
        return this.listadoArticulos.length;
    }

    generarOrder(extra){
        if (this.getCantidadArticulos() > 0) {
            return this.$http.post(this.ORDENES_URL, {mensaje: extra.mensaje, articulos: this.getArticulosCarrito(), envio: extra.envio});
        }
    }

    _actualizarCookies(){
        let expires = new Date();
        expires.setTime(expires.getTime() + 31556952000); // 1 year
        this.$cookies.putObject('carrito', {articulos: this.getArticulosCarrito()}, { expires });
    }
}



// WEBPACK FOOTER //
// ./client/app/carrito-route/carrito-route.service.js